import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HypoallergenicIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HypoallergenicIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M13.4484 10.7563C10.9614 10.7563 8.93799 12.7797 8.93799 15.2668C8.93799 17.7539 10.9614 19.7772 13.4484 19.7772C15.9355 19.7772 17.9589 17.7539 17.9589 15.2668C17.9589 12.7797 15.9355 10.7563 13.4484 10.7563ZM13.4484 18.6006C11.6102 18.6006 10.1146 17.1051 10.1146 15.2668C10.1146 13.4285 11.6102 11.933 13.4484 11.933C15.2867 11.933 16.7822 13.4285 16.7822 15.2668C16.7822 17.1051 15.2867 18.6006 13.4484 18.6006Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.5955 13.7421L12.7929 15.5448L12.0995 14.8515C11.8698 14.6217 11.4973 14.6217 11.2675 14.8515C11.0378 15.0813 11.0378 15.4537 11.2675 15.6835L12.3769 16.7928C12.6066 17.0226 12.9791 17.0226 13.2089 16.7928L15.4275 14.5742C15.6573 14.3444 15.6573 13.9719 15.4275 13.7422C15.1978 13.5124 14.8253 13.5124 14.5955 13.7421Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.205 11.1328L13.9533 2.3361C13.725 1.95377 13.1713 1.95377 12.943 2.3361L10.8477 5.84574C10.703 5.6263 10.5341 5.41901 10.3408 5.22577L10.3304 5.21553C9.4383 4.36678 8.57029 4.00916 7.80442 3.69362C6.97556 3.35212 6.32083 3.08239 5.71251 2.28173C5.45279 1.93992 4.92628 1.98239 4.72468 2.36139C4.70479 2.39877 4.23649 3.28952 4.07588 4.48962C3.8564 6.12935 4.30976 7.56547 5.38701 8.64269C6.22807 9.48375 7.33964 9.88781 8.32171 10.0769L7.69131 11.1328C6.95011 12.3744 6.55828 13.7949 6.55828 15.2409C6.55828 19.0399 9.64904 22.1307 13.4482 22.1307C17.2473 22.1307 20.338 19.0399 20.338 15.2408C20.338 13.7949 19.9462 12.3743 19.205 11.1328ZM5.23765 4.67985C5.28342 4.31952 5.36426 3.9901 5.44905 3.71579C6.06643 4.25018 6.71923 4.51912 7.35619 4.78155C8.09002 5.08387 8.78322 5.36948 9.51387 6.06283C10.3079 6.86067 10.3633 7.82026 10.2629 8.50122L8.17509 6.41339C7.94533 6.18363 7.57285 6.18363 7.34309 6.41339C7.11333 6.64315 7.11333 7.01563 7.34309 7.24539L9.1046 9.00694C8.18972 8.90508 7.01834 8.60998 6.21897 7.81065C5.40697 6.99865 5.07681 5.94528 5.23765 4.67985ZM13.4482 20.954C10.2979 20.954 7.73491 18.3911 7.73491 15.2408C7.73491 14.0072 8.06915 12.7952 8.70156 11.7359L9.60373 10.2248C9.74771 10.231 9.88087 10.2336 9.99928 10.2336C10.35 10.2336 10.5772 10.2127 10.6112 10.2094C10.8178 10.189 10.9984 10.0613 11.0865 9.87323C11.0993 9.84589 11.4007 9.19294 11.4627 8.31069C11.4894 7.93024 11.4685 7.56325 11.4016 7.21324L13.4481 3.78537L18.1947 11.7359C18.8271 12.7952 19.1614 14.0072 19.1614 15.2408C19.1614 18.3911 16.5984 20.954 13.4482 20.954Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HypoallergenicIcon;
